/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_To_EventInputs */

const en_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Event...`)
};

const fr_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller à l'événement...`)
};

const de_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Veranstaltung...`)
};

const it_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai all'evento...`)
};

const ru_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к мероприятию...`)
};

const es_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al evento...`)
};

const zh_cn2_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往活动页面...`)
};

const ja_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントへ移動...`)
};

const hi_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट पर जाएं...`)
};

const pt_pt2_go_to_event = /** @type {(inputs: Go_To_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesse o evento...`)
};

/**
* | output |
* | --- |
* | "Go to Event..." |
*
* @param {Go_To_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const go_to_event = /** @type {((inputs?: Go_To_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_go_to_event(inputs)
	if (locale === "de") return de_go_to_event(inputs)
	if (locale === "it") return it_go_to_event(inputs)
	if (locale === "ru") return ru_go_to_event(inputs)
	if (locale === "es") return es_go_to_event(inputs)
	if (locale === "zh-CN") return zh_cn2_go_to_event(inputs)
	if (locale === "ja") return ja_go_to_event(inputs)
	if (locale === "hi") return hi_go_to_event(inputs)
	if (locale === "pt-PT") return pt_pt2_go_to_event(inputs)
	return en_go_to_event(inputs)
});